import React from 'react';
import { LoadingComponent } from './LoadingComponent';

export const withLoadingCondition = (isLoading = false, renderComponent) =>
    isLoading ? <LoadingComponent /> : renderComponent();



// WEBPACK FOOTER //
// ./src/components/loading/withLoadingCondition.js